module.exports = __webpack_public_path__ + "img/doge.7f63ff39.svg";